import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/home/SectionLabel";
import { ArrowUpRight } from "lucide-react";

export function PricingSection() {
    return (
        <section className="bg-stone2/50 border-y border-linec">
            <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-20">
                <Reveal>
                    <SectionLabel className="text-terracotta">Pricing</SectionLabel>
                    <h2 className="font-heading text-4xl sm:text-5xl tracking-tight text-ink mt-4 max-w-2xl">
                        Simple pricing. No long-term contracts.
                    </h2>
                </Reveal>
                <div className="mt-12 grid md:grid-cols-2 border border-linec rounded-sm overflow-hidden">
                    <Reveal>
                        <div className="p-10 bg-cream border-b md:border-b-0 md:border-r border-linec h-full">
                            <h3 className="font-heading text-2xl text-ink">Percentage of collections</h3>
                            <p className="text-sm text-inksoft leading-relaxed mt-4">
                                Pay a share of what we actually collect. Our incentives line up with
                                yours — we get paid when you get paid.
                            </p>
                        </div>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <div className="p-10 bg-cream h-full">
                            <h3 className="font-heading text-2xl text-ink">Flat monthly fee</h3>
                            <p className="text-sm text-inksoft leading-relaxed mt-4">
                                A predictable per-provider monthly rate. No hidden setup fees, no
                                surprises on the invoice.
                            </p>
                        </div>
                    </Reveal>
                </div>
                <Reveal delay={0.15}>
                    <div className="mt-8">
                        <Link
                            to="/contact"
                            data-testid="pricing-cta-button"
                            className="inline-flex items-center gap-2 text-sage font-medium hover:text-terracotta transition-colors group"
                        >
                            Request a quote based on your practice
                            <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                        </Link>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
